// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconRefine = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.529 13.27a2.834 2.834 0 00-3.872 2.118H5.002a.5.5 0 000 1h2.655l.01.054a2.833 2.833 0 005.567-.054H19a.5.5 0 100-1h-5.766a2.839 2.839 0 00-1.705-2.117zm-1.084.785a1.834 1.834 0 11.001 3.668 1.834 1.834 0 01-.001-3.668zM15.208 9.78a1.833 1.833 0 101.401-3.387 1.833 1.833 0 00-1.401 3.388zm.702 1.14a2.834 2.834 0 01-2.79-2.333H5.002a.5.5 0 010-1h8.118a2.832 2.832 0 015.567-.053c.066.33.053.713.01 1.053a2.827 2.827 0 01-1.214 1.855 2.833 2.833 0 01-1.573.478z"
      fill="currentColor"
    />
  );
export default SvgIconRefine;
